<template>
  <div class="helper-list-container">
    <div
      v-if="currentView === 'allocations'"
      class="helper-list"
    >
      <div class="list-type">
        <input
          id="contracts"
          type="checkbox"
          name="contracts"
          class="contracts"
          @change="showContracts"
        />
        <span>Contracts</span>
      </div>
      <!-- eslint-disable vue/no-v-html -->
      <div class="helper-item">
        <span
          v-for="contract in contracts"
          :key="contract"
          v-html="contract"
        />
      </div>
      <!--eslint-enable-->
    </div>
    <div class="helper-list">
      <div class="list-type">
        <span>Select</span>
      </div>
      <div
        v-if="currentView === 'attendance'"
        class="helper-item"
      >
        <span>
          <span> Unapproved </span>
          <input
            id="select-unapproved"
            v-model="isSelectUnapproved"
            type="checkbox"
            name="select-unapproved"
            label="Unapproved"
            @change="selectUnapprovedFn"
          />
          <span> Hide unselected </span>
          <input
            id="hide-unselected"
            v-model="isHideUnselected"
            type="checkbox"
            name="hide-unselected"
            label="Hide Unselected"
            @change="hideUnselectedFn"
          />

        </span>
      </div>
    </div>
    <div
      v-if="currentView === 'attendance' && canViewWeeklyReview"
      class="helper-list review-helper-list"
    >
      <div class="list-type">
        <span>Review</span>
      </div>
      <div class="helper-item review-actions">
        <label class="review-toggle">
          <input
            type="checkbox"
            :checked="weeklyReviewMode"
            @change="toggleWeeklyReviewMode"
          />
          Weekly Review
        </label>
        <template v-if="weeklyReviewMode">
          <label class="weekly-picker-inline">
            Week Start
            <input
              type="date"
              :value="selectedWeekStart"
              :min="weekPickerMinDate"
              :max="weekPickerMaxDate"
              step="7"
              @change="onWeeklyStartChange"
            />
          </label>
          <span
            v-if="weeklyRangeDisplay"
            class="weekly-range-display"
          >
            {{ weeklyRangeDisplay }}
          </span>
        </template>
      </div>
    </div>
    <div class="helper-list">
      <div class="list-type">
        <input
          id="sites"
          type="checkbox"
          name="sites"
          class="sites"
          @change="showSites"
        />
        <span>Sites</span>
      </div>
      <!-- eslint-disable vue/no-v-html -->
      <div class="helper-item">
        <span
          v-for="site in sites"
          :key="site"
          v-html="site"
        />
      </div>
      <!--eslint-enable-->
    </div>
    <div
      v-if="currentView === 'attendance'"
      class="helper-list"
    >
      <div class="list-type">
        <input
          id="designations"
          type="checkbox"
          name="designations"
          class="designations"
          @change="showDesignations"
        />
        <span>Designations</span>
      </div>
      <!-- eslint-disable vue/no-v-html -->
      <div class="helper-item">
        <span
          v-for="designation in designations"
          :key="designation"
          v-html="designation"
        />
      </div>
      <!--eslint-enable-->
    </div>
    <div
      v-if="currentView === 'attendance'"
      class="helper-list"
    >
      <div class="list-type">
        <!-- <input
          id="designations"
          type="checkbox"
          name="designations"
          class="designations"
          checked
          @change="showAttendanceType"
        /> -->
        <span>Attendance Type</span>
      </div>
      <!-- eslint-disable vue/no-v-html -->
      <div class="helper-item">
        <span
          v-for="att_type in att_types"
          :key="att_type"
          v-html="att_type"
        />
      </div>
      <!--eslint-enable-->
    </div>
    <div>
      <v-icon
        :fill="`#292929`"
        name="bi-three-dots-vertical"
        scale="1.5"
        class="filter-icon"
      />
    </div>
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import attendanceGridUtils from '../../../composables/attendanceGridUtils';

export default {
  name: 'HelperList',
  props: {
    gridView: {
      type: String,
      default: () => ''
    },
    helperListData: {
      type: Object,
      default: () => {}
    },
    selectUnapproved: {
      type: Function,
      default: () => {}
    },
    hideUnselected: {
      type: Function,
      default: () => {}
    },
    showDesignation: {
      type: Function,
      default: () => (false)
    },
    showSite: {
      type: Function,
      default: () => (false)
    },
    showContract: {
      type: Function,
      default: () => (false)
    },
    canViewWeeklyReview: {
      type: Boolean,
      default: () => false
    },
    weeklyReviewMode: {
      type: Boolean,
      default: () => false
    },
    selectedWeekStart: {
      type: String,
      default: () => ''
    },
    weeklyRangeDisplay: {
      type: String,
      default: () => ''
    },
    weekPickerMinDate: {
      type: String,
      default: () => ''
    },
    weekPickerMaxDate: {
      type: String,
      default: () => ''
    },
    canGoToPreviousWeek: {
      type: Boolean,
      default: () => false
    },
    canGoToNextWeek: {
      type: Boolean,
      default: () => false
    },
    onWeeklyReviewModeToggle: {
      type: Function,
      default: () => {}
    },
    onWeeklyRangeChange: {
      type: Function,
      default: () => {}
    },
    goToPreviousWeek: {
      type: Function,
      default: () => {}
    },
    goToNextWeek: {
      type: Function,
      default: () => {}
    },
    goToCurrentWeek: {
      type: Function,
      default: () => {}
    },
    approveSelectedWeeklyRows: {
      type: Function,
      default: () => {}
    },
    rejectSelectedWeeklyRows: {
      type: Function,
      default: () => {}
    },
    clearWeeklySelection: {
      type: Function,
      default: () => {}
    },
    weeklyReviewRowCount: {
      type: Number,
      default: () => 0
    }
  },
  setup(props) {
    const { getRandomColor } = attendanceGridUtils();
    const currentView = ref(props.gridView);

    const showDesignations = () => {
      props.showDesignation();
    };

    const selectUnapprovedFn = () => {
      props.selectUnapproved(isSelectUnapproved.value);
    }

    const hideUnselectedFn = () => {
      props.hideUnselected(isHideUnselected.value);
    }

    const showSites = () => {
      props.showSite();
    };

    const showContracts = () => {
      props.showContract();
    }

    const toggleWeeklyReviewMode = (event) => {
      props.onWeeklyReviewModeToggle(event?.target?.checked === true);
    };

    const onWeeklyStartChange = (event) => {
      props.onWeeklyRangeChange(event?.target?.value ?? '');
    };

    const goToPreviousWeekFn = () => {
      props.goToPreviousWeek();
    };

    const goToNextWeekFn = () => {
      props.goToNextWeek();
    };

    const goToCurrentWeekFn = () => {
      props.goToCurrentWeek();
    };

    const approveSelectedWeeklyRowsFn = () => {
      props.approveSelectedWeeklyRows();
    };

    const rejectSelectedWeeklyRowsFn = () => {
      props.rejectSelectedWeeklyRows();
    };

    const clearWeeklySelectionFn = () => {
      props.clearWeeklySelection();
    };

    const contracts = computed(() => {
      if (!props.helperListData.contracts_id) return [];
      return props.helperListData.contracts_id.map((item) => {
        const randomColor = getRandomColor('sites_id', item.name.eng, 0.5);
        return `<span data-original-value="${item.name.eng}" style="background-color: ${randomColor}; padding: 4px; border-radius: 10%; text-wrap: nowrap" onmouseover="this.textContent='${item.name.eng}'" onmouseout="this.textContent='${item.name.eng}'">${item.name.eng}</span>`;
      });
    });

    const isSelectUnapproved = ref(false);
    const isHideUnselected = ref(false);

    const sites = computed(() => {
      if (!props.helperListData.sites_id) return [];
      return props.helperListData.sites_id.map((item) => {
        const randomColor = getRandomColor('sites_id', item?.name?.eng, 0.5);
        return `<span data-original-value="${item?.name?.eng}" style="background-color: ${randomColor}; padding: 4px; border-radius: 10%; text-wrap: nowrap" onmouseover="this.textContent='${item?.name?.eng}'" onmouseout="this.textContent='${item?.name?.eng}'">${item?.name?.eng}</span>`;
      });
    });

    const designations = computed(() => {
      if (!props.helperListData.designation) return [];
      return props.helperListData.designation.map((item) => {
        const randomColor = getRandomColor('designation', item.name + '__' + item.code, 1);
        return `<span data-original-value="${item.code}" style="background-color: ${randomColor}; padding: 4px; border-radius: 10%; text-wrap: nowrap" onmouseover="this.textContent='${item.name}'" onmouseout="this.textContent='${item.name}'">${item.name}</span>`;
      });
    });

    const att_types = computed(() => {
      if (!props.helperListData.att_type) return [];
      return props.helperListData.att_type.map((item) => {
        let color = ''
        if (item.code === 'P') {
          color = 'rgb(182 247 182)';
        } else if (item.code === 'A') {
          color = 'rgb(245 210 209)';
        } else if (item.code === 'H') {
          color = 'rgb(199 237 249)'
        } else if (item.code === 'SP') {
          color = ' #FFFFE0'
        } else if (item.code === 'PR') {
          color = '#D3D3D3'
        } else {
          color = 'rgb(255 234 191)'
        }
        return `<span data-original-value="${item?.code}" style="background-color: ${color}; padding: 4px; border-radius: 10%; text-wrap: nowrap" onmouseover="this.textContent='${item?.name?.eng}'" onmouseout="this.textContent='${item?.name?.eng}'">${item?.name?.eng}</span>`;
      })
    })

    return {
      currentView,
      contracts,
      designations,
      sites,
      showContracts,
      isSelectUnapproved,
      selectUnapprovedFn,
      isHideUnselected,
      hideUnselectedFn,
      showDesignations,
      showSites,
      att_types,
      toggleWeeklyReviewMode,
      onWeeklyStartChange,
      goToPreviousWeekFn,
      goToNextWeekFn,
      goToCurrentWeekFn,
      approveSelectedWeeklyRowsFn,
      rejectSelectedWeeklyRowsFn,
      clearWeeklySelectionFn
    };
  }
}
</script>

<style>
.helper-list-container {
  background-color: rgba(255, 255, 255, 0);
  position: fixed;
  width: 100%;
  z-index: 1;
  color: #292929;
  display: flex;
  justify-content: space-around;
}

.list-type {
  display: flex;
  justify-content:center;
  align-items: center;
  font-size: 12px;
  padding: 0 2px;
  margin-bottom: 2px;
  border: 0.1px solid #00b7ff;
  background-color: rgb(213, 210, 210);
  border-radius: 5px;
}

.helper-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  height: 9vh;
  padding: 2px;
}

.helper-list-type {
  margin-right: 10px;
}

.helper-list span {
  font-size: 12px;
  margin: 5px;
}

.helper-item {
  display: flex;
  scrollbar-width: thin;
  overflow-x: scroll;
  width: 500px;
  background-color: white;
}

.review-helper-list .helper-item {
  width: 880px;
}

.review-actions {
  align-items: center;
  gap: 8px;
  padding: 2px 6px;
  flex-wrap: wrap;
}

.review-toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  white-space: nowrap;
}

.review-actions button {
  background-color: #aebbcc;
  border-radius: 4px;
  border: 1px solid #83ACC8;
  padding: 2px 8px;
  font-size: 12px;
}

.review-actions button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.weekly-picker-inline {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
}

.weekly-range-display {
  font-size: 12px;
  font-weight: 600;
  color: #22313f;
  white-space: nowrap;
}

.weekly-count-inline {
  font-size: 12px;
  font-weight: 600;
  color: #22313f;
}

.review-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  margin: 0 2px;
  white-space: nowrap;
}

.review-legend-swatch {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  border: 1px solid transparent;
  display: inline-block;
}
</style>
